/**
 * Picks v2 or v1 of the Captions Vocabulary page based on the
 * redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import CaptionsVocabularyPage   from './CaptionsVocabularyPage';
import CaptionsVocabularyPageV2 from './CaptionsVocabularyPageV2';

export default function CaptionsVocabularyPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? CaptionsVocabularyPageV2 : CaptionsVocabularyPage;
  return <Component {...props} />;
}
